import React, { lazy, Suspense } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Loading from "./components/loading";
import { useEffect } from "react";
const Error = lazy(() => import("./pages/error/index"));
const Home = lazy(() => import("./pages/homepage/index"));

export function Router() {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/*" element={<Error />} />

        {/* Homepage */}
        <Route path="/" element={<Home />} />
        {/* Homepage */}
      </Routes>
    </Suspense>
  );
}
